<template>
  <div>
    <base-info-card
      :title="title"
      :subtitle="subtitle"
      space="4"
      color="primary"
    />

    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :color="color"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <base-text-field label="Nom" v-model="name" />

    <base-text-field label="E-mail" v-model="email" />

    <base-text-field label="Sujet" v-model="subject" />

    <base-textarea
      class="mb-6"
      label="Votre mail"
      v-model="content"
    />

    <base-btn
      :color="!theme.isDark ? 'accent' : 'white'"
      outlined
      @click="sendMail"

    >
      Envoyer
    </base-btn>
  </div>
</template>

<script>
  export default {
    name: 'BaseContactForm',

    // Injected from the Vuetify Themeable mixin
    inject: ['theme'],

    methods : {
      sendMail(){
        let data = new FormData();
        data.append('name', this.name)
        data.append('content', this.content)
        data.append('email', this.email)
        data.append('subject', this.subject)
        fetch(this.endpoint, {
          method: 'post',
          body: data,
        })
          .then((res) => {
            console.log(res)
            this.text = "Mail bien envoyé";
            this.snackbar = true
            this.content = ""
            this.subject = ""
            this.email = ""
            this.name = ""
          })
          .catch((e) => {
            this.text = "Mail non envoyé, veuillez vérifier les données saisies";
            this.snackbar = true
            console.log(e)
          })
      }
    },

    data() {
      return {
        endpoint : 'http://pronewtecmailsender.pronewtec.fr/',
        name : '',
        email : '',
        subject : '',
        content : '',
        color: '',
        mode: '',
        snackbar: false,
        text: '',
        timeout: 6000,
        x: null,
        y: 'top',
      }
    },
    props: {
      subtitle: String,
      title: {
        type: String,
        default: 'MAIL US YOUR MESSAGE',
      },
    },
  }
</script>
